/* eslint-disable */
import {
  $DomainEntity,
  $DomainEntityReflection,
  EnhancedAliasReflection,
  Violation,
} from '@salsita-ai/platform-project-sdk/domain'

import {
  Admin,
  ConnectedDataConfig,
  DataTable,
  DummyDoNotUse,
  Preset,
  PresetCategory,
  PricingSettings,
  Recipe,
} from './admin-model/index.js'

export const constants = {} as const

interface PresetCategoryExpressions {
  readonly $isDraft: boolean
  readonly $admin: $Admin
  readonly $presets: readonly $Preset[]
}
const PresetCategoryExpressions = ['$isDraft', '$admin', '$presets']

interface AdminExpressions {
  readonly $pricingSettings: readonly $PricingSettings[]
  readonly $presets: readonly $Preset[]
  readonly $presetCategories: readonly $PresetCategory[]
  readonly $recipes: readonly $Recipe[]
  readonly $connectedDataConfigs: readonly $ConnectedDataConfig[]
  readonly $dataTables: readonly $DataTable[]
}
const AdminExpressions = [
  '$pricingSettings',
  '$presets',
  '$presetCategories',
  '$recipes',
  '$connectedDataConfigs',
  '$dataTables',
]

interface PricingSettingsExpressions {
  readonly $admin: $Admin
}
const PricingSettingsExpressions = ['$admin']

interface PresetExpressions {
  readonly $admin: $Admin
  readonly $category: $PresetCategory | null
  readonly $violations: ReadonlyArray<Violation<'nameCanNotBeEmpty'>>
}
const PresetExpressions = ['$admin', '$category', '$violations']

interface RecipeExpressions {
  readonly $admin: $Admin
}
const RecipeExpressions = ['$admin']

interface ConnectedDataConfigExpressions {
  readonly $admin: $Admin
}
const ConnectedDataConfigExpressions = ['$admin']

interface DataTableExpressions {
  readonly $admin: $Admin
}
const DataTableExpressions = ['$admin']

export type $Admin = $DomainEntity<Admin> & AdminExpressions
export const $Admin: $DomainEntityReflection<$Admin> = new $DomainEntityReflection('Admin', [...AdminExpressions])

export type $Preset = $DomainEntity<Preset> & PresetExpressions
export const $Preset: $DomainEntityReflection<$Preset> = new $DomainEntityReflection('Preset', [...PresetExpressions])

export type $PresetCategory = $DomainEntity<PresetCategory> & PresetCategoryExpressions
export const $PresetCategory: $DomainEntityReflection<$PresetCategory> = new $DomainEntityReflection('PresetCategory', [
  ...PresetCategoryExpressions,
])

export type $Recipe = $DomainEntity<Recipe> & RecipeExpressions
export const $Recipe: $DomainEntityReflection<$Recipe> = new $DomainEntityReflection('Recipe', [...RecipeExpressions])

export type $ConnectedDataConfig = $DomainEntity<ConnectedDataConfig> & ConnectedDataConfigExpressions
export const $ConnectedDataConfig: $DomainEntityReflection<$ConnectedDataConfig> = new $DomainEntityReflection(
  'ConnectedDataConfig',
  [...ConnectedDataConfigExpressions]
)

export type $DataTable = $DomainEntity<DataTable> & DataTableExpressions
export const $DataTable: $DomainEntityReflection<$DataTable> = new $DomainEntityReflection('DataTable', [
  ...DataTableExpressions,
])

export type $DummyDoNotUse = $DomainEntity<DummyDoNotUse>
export const $DummyDoNotUse: $DomainEntityReflection<$DummyDoNotUse> = new $DomainEntityReflection('DummyDoNotUse', [])

export type $PricingSettings = $DomainEntity<PricingSettings> & PricingSettingsExpressions
export const $PricingSettings: $DomainEntityReflection<$PricingSettings> = new $DomainEntityReflection(
  'PricingSettings',
  [...PricingSettingsExpressions]
)

export type $AnyDomainEntity =
  | $Admin
  | $Preset
  | $PresetCategory
  | $Recipe
  | $ConnectedDataConfig
  | $DataTable
  | $DummyDoNotUse
  | $PricingSettings
export const $AnyDomainEntity: EnhancedAliasReflection<$AnyDomainEntity> = new EnhancedAliasReflection(
  '$AnyDomainEntity',
  [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    ConnectedDataConfig.type,
    DataTable.type,
    DummyDoNotUse.type,
    PricingSettings.type,
  ]
)

export type $RootEntity = $Admin
export const $RootEntity: EnhancedAliasReflection<$RootEntity> = new EnhancedAliasReflection('$RootEntity', [
  Admin.type,
])

export type $CommonAdminEntity = $Admin | $Preset | $PresetCategory | $Recipe | $ConnectedDataConfig | $DataTable
export const $CommonAdminEntity: EnhancedAliasReflection<$CommonAdminEntity> = new EnhancedAliasReflection(
  '$CommonAdminEntity',
  [Admin.type, Preset.type, PresetCategory.type, Recipe.type, ConnectedDataConfig.type, DataTable.type]
)

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type $Map = {
  Admin: $Admin
  Preset: $Preset
  PresetCategory: $PresetCategory
  Recipe: $Recipe
  ConnectedDataConfig: $ConnectedDataConfig
  DataTable: $DataTable
  DummyDoNotUse: $DummyDoNotUse
  PricingSettings: $PricingSettings
  AnyDomainEntity: $AnyDomainEntity
  RootEntity: $RootEntity
  CommonAdminEntity: $CommonAdminEntity
}

export const $entityReflections = {
  Admin: $Admin,
  Preset: $Preset,
  PresetCategory: $PresetCategory,
  Recipe: $Recipe,
  ConnectedDataConfig: $ConnectedDataConfig,
  DataTable: $DataTable,
  DummyDoNotUse: $DummyDoNotUse,
  PricingSettings: $PricingSettings,
}

declare global {
  interface EnhancedAdminModel {
    readonly $Admin: $Admin
    readonly $Preset: $Preset
    readonly $PresetCategory: $PresetCategory
    readonly $Recipe: $Recipe
    readonly $ConnectedDataConfig: $ConnectedDataConfig
    readonly $DataTable: $DataTable
    readonly $DummyDoNotUse: $DummyDoNotUse
    readonly $PricingSettings: $PricingSettings

    readonly $AnyDomainEntity: $AnyDomainEntity
    readonly $RootEntity: $RootEntity
    readonly $CommonAdminEntity: $CommonAdminEntity
  }
}
